import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  OnInit,
} from '@angular/core';
import { TranslationService } from '@proximus/ng-common';
import {
  LevelType,
  MessageType,
  PxModalMessageService,
} from '@proximus/ng-common-components';
import {
  EntityManager,
  IEntityManagerConfiguration,
} from '@proximus/entity-manager';
import { ProductConfig } from '../configs/product.config';
import { savePii } from '../shared/pii/pii.utils';

declare const postal: any;

@Component({
  selector: 'mprd-app',
  templateUrl: 'mprd-app.component.html',
  changeDetection: ChangeDetectionStrategy.Default,
})
export class MprdAppComponent implements OnInit {
  serviceId: string;

  // unbilled balance, bipt, usage, netflix web token, norton, cloud
  private failInSilenceList = [
    'ubl:unbilledBalances',
    'upmp:averageusagelinks',
    'uptv:usage',
    'upi:usage',
    'upmp:usage',
    'upft:usage',
    'pda:webTokenNetflix',
    'nar:nortonaccountregistrationsmypx',
    'psc:getaccountstatus',
    'psc:accountactivation',
    'sw:createSmartWifiAlias',
    'sw:renameSmartWifiAlias',
    'sw:updateSmartWifiPassword',
    'psi:updateinternetpassword',
    'psi:updateModemSafetySettingsEntity',
    'psi:updateSharedIpSettingsEntity',
    'psi:updatewifissid',
    'psi:getwifissid',
    'psi:getModemSafetySettings',
    'pc:monitored-speed',
    'pda:mobileproductsavailableoptions',
    'pda:tvproductsavailableoptions',
    'pda:internetproductsavailableoptions',
    'pda:mobileproductsavailablesettings',
    'po:optionlock',
    'po:optionconfigurationlock',
    'mbx:checkAlias',
    'es:easyswitch',
    'mhgw:get-wifi-information',
    'of:offers',
    'pda:bcgTokenDisneyBuyAndSell',
    'ubl:splitUnbilledBalance',
    'psi:macipaddress',
  ];

  constructor(
    private translationService: TranslationService,
    private elementRef: ElementRef,
    private pxModalMessageService: PxModalMessageService,
  ) {}

  ngOnInit() {
    this.translationService.parse(this.elementRef.nativeElement);
    EntityManager.configure(ProductConfig);
    // tweak the entity manager configuration to define a generic callback function for all calls
    const updatedConfig = <IEntityManagerConfiguration>{
      ...(<any>EntityManager).configurationService.configuration,
      onErrorCallback: (entity) => {
        let title;
        let message;
        let testId;
        if (entity && entity.errorData && entity.errorData.message) {
          if (
            (<string>entity.errorData.message).indexOf('Timeout') > -1 &&
            this.failInSilenceList.indexOf(entity.rel) === -1
          ) {
            title = this.translationService.getTranslatedValueFor(
              'products.timeout.error.message.title',
            );
            message = this.translationService.getTranslatedValueFor(
              'products.timeout.error.message',
            );
          } else if (
            entity &&
            entity.status !== 404 &&
            this.failInSilenceList.indexOf(entity.rel) === -1
          ) {
            title = this.translationService.getTranslatedValueFor(
              'products.technical.error.message.title',
            );
            message = this.translationService.getTranslatedValueFor(
              'products.technical.error.message',
            );
            testId = 'technicalError';
          }
        }

        if (title && message) {
          this.pxModalMessageService.dispatchMessage(
            MessageType.Error,
            LevelType.Root,
            message,
            title,
            false,
            true,
            testId,
          );
        }
      },
    };
    EntityManager.configure(updatedConfig);
    setTimeout(() => {
      if (
        window.location.host.includes('itt') ||
        window.location.host.includes('uat') ||
        window.location.host.includes('localhost')
      ) {
        postal.addWireTap(function (d: any, e: any) {
          console.log(JSON.stringify(e, null, 4));
        });
      }
    }, 2000);
  }

  isLocalhost() {
    return window.location.host.includes('localhost');
  }

  saveServiceId() {
    savePii(this.serviceId);
    window.location.reload();
  }
}
